import { groupBy, prop, uniqBy } from 'ramda';
import { ProductOption, ProductSubGroup } from './data';

export const deconstructDoc = (pcModel) => {
  try {
    /**
     * @type {ProductOption[]} options
     */
    const options = [];
    /**
     * @type {ProductSubGroup[]} subGroups
     */
    const subGroups = [];

    if (!pcModel) {
      return {
        options: [],
        sub_groups: [],
      };
    }

    pcModel?.modelOptionGroup?.forEach((modelOptionGroup) => {
      modelOptionGroup?.options.forEach((option) => {
        subGroups.push(
          new ProductSubGroup({
            group_type: modelOptionGroup?.optionGroup?.option_group_title,
            sub_group_name: option?.optionSubGroup?.option_sub_group_title,
            sub_group_title: option?.optionSubGroup?.option_sub_group_title,
            sub_group_description:
              option?.optionSubGroup?.option_sub_group_description,
            pc_model_uid: pcModel.slug,
            pc_model_title: pcModel.model_title,
            o_price: pcModel.price,

            option_id: option.option_id,
            option_sub_group_id: option?.optionSubGroup?.option_sub_group_id,
          }),
        );

        options.push(
          new ProductOption({
            price: option?.price,
            option_id: option?.option_id,
            group_type: modelOptionGroup?.optionGroup?.option_group_title,
            group_title: modelOptionGroup?.optionGroup?.option_group_title,
            option_sub_group_id: option?.optionSubGroup?.option_sub_group_id,
            group_step_new: modelOptionGroup?.configStep?.config_step_title,
            id: option?.component.component_id,
            title: option?.component.component_title,
            sku: option?.component.sku,
            is_base: option?.base !== 0,
            // TODO: no data
            is_recommended: false,
            image: getImage(option),
            variant_id: option?.component.variant_id,
            tags: extractTags(option?.component.tags),
            pc_model_uid: pcModel.slug,
            pc_model_title: pcModel.model_title,
            o_price: pcModel.price
            // filter_by_brand: false,
          }),
        );
      });
    });

    const fixedOptions = fixOptionsBaseOption(options);

    return {
      options: uniqBy(prop('option_id'), fixedOptions),
      sub_groups: subGroups,
    };
  } catch (err) {
    console.error('deconstructDoc', err);
    return [];
  }
};
export const deconstructDocNext = (pcModel) => {
  try {
    /**
     * @type {ProductOption[]} options
     */
    const options = [];
    if (!pcModel) {
      return {
        options: [],
      };
    }
    options.push(
      new ProductOption({
        price: pcModel.product?.variants[0].price,
        id: pcModel.product.id,
        title: pcModel.product?.title,
        sku: pcModel.product?.variants[0].sku,
        variants: pcModel.product?.variants,
        is_base: 1,
        is_recommended: false,
        image: getImageRTS(pcModel),
        variant_id: pcModel.product?.variants[0].id,
        tags: extractTags(pcModel.product?.tags),
        pc_model_uid: pcModel.slug,
      }),
    );

    return {
      options: options,
    };
  } catch (err) {
    console.error('deconstructDoc', err);
    return [];
  }
};

function fixOptionsBaseOption(options) {
  const fixedOptions = [...options];
  const groupByGroupType = groupBy((item) => item.group_type);
  const optionsByGroupType = groupByGroupType(options);
  const groupTypes = Object.keys(optionsByGroupType);

  groupTypes?.forEach((groupType) => {
    const groupBaseOption = options.find(
      (option) => option.group_type === groupType && option.is_base,
    );

    if (!groupBaseOption) {
      const firstOptionIndex = options.findIndex(
        (option) => option.group_type === groupType,
      );

      fixedOptions[firstOptionIndex].is_base = true;
    }
  });
  return fixedOptions;
}

function getImageRTS(option) {
  const alt = option.product.title;
  const componentImageUrl =
    option.product.images[0]?.src || '/images/image-placeholder.png';

  return {
    src: componentImageUrl,
    alt,
    // TODO: There is no dimensions in DB, so use fixed sizes for now
    width: 300,
    height: 300,
  };
}

function getImage(option) {
  const alt = option.component.component_title;
  const componentImageUrl =
    option.component.image || '/images/image-placeholder.png';

  return {
    src: componentImageUrl,
    alt,
    // TODO: There is no dimensions in DB, so use fixed sizes for now
    width: 300,
    height: 300,
  };
}

export const extractTags = (tags) => {
  if (!tags) {
    return [[], [], [], []];
  }

  const attrTags = tags
    .split(', ')
    .filter((item) => item.startsWith('attr:'))
    .map((item) => {
      const [, name, value] = item.split(':');
      return { name, value };
    });

  const reqTags = tags
    .split(', ')
    .filter((item) => item.startsWith('req:'))
    .map((item) => {
      const [, name, operator, value] = item.split(':');
      return { name, operator, value };
    });

  const aggrReqTags = tags
    .split(', ')
    .filter((item) => item.startsWith('aggr:'))
    .map((item) => {
      const [, , name, operator, value] = item.split(':');
      return { name, operator, value };
    });

  const presentationTags = tags
    .split(', ')
    .filter((item) => item.startsWith('hide:'))
    .map((item) => {
      const [, name, operator, value] = item.split(':');
      return { name, operator, value };
    });

  return [attrTags, reqTags, aggrReqTags, presentationTags];
};
